// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"facf244c","453":"02149478","583":"0e7c1f0d","645":"865fbc2e"}[chunkId] + ".chunk.js";
};